import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'

// Containers
import { DefaultLayout } from './containers';
// Pages
import {
  Login,
  Page404,
  Page500,
  Setting,
  ForgetPw,
  ChangePw,
  Register,
  List,
  Home,
  Help,
  ContactUs,
  TOC,
  PP
} from './views/Pages';
// import ChangePW from './views/Pages/Mysetting/ChangePW'

// import { renderRoutes } from 'react-router-config';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/home" name="Home Page" component={Home} />
          <Route path="/login" name="Login Page" component={Login} />
          <Route path="/list/:idx" name="List" component={List} />
          <Route path="/list" name="List" component={List} />
          <Route path="/setting" name="Setting" component={Setting} />
          <Route path="/setting/:idx" name="Setting" component={Setting} />
          <Route path="/forgetpw" name="Forget Password" component={ForgetPw} />
          <Route path="/changepw" name="Change Password" component={ChangePw} />
          <Route path="/register" name="Register" component={Register} />
          <Route path="/help" name="Help" component={Help} />
          <Route path="/contact" name="Contact" component={ContactUs} />
          <Route path="/toc" name="TOC" component={TOC} />
          <Route path="/pp" name="PP" component={PP} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <Route path="/" name="Home" component={DefaultLayout} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js